import { useQuery } from '@tanstack/react-query';
import { getPrescriptionService } from '../../../domains/prescriptions';

interface UseUserPrescriptionsOptions {
  limit?: number;
  skip?: number;
}

/**
 * 환자별 처방전 리스트 조회.
 * 응답: { prescriptions: [{ id, image_url, analysis: { medications, ... }, ... }] }
 */
export const useUserPrescriptions = (
  userId: number | string | null | undefined,
  options: UseUserPrescriptionsOptions = {}
) => {
  const { limit = 20, skip = 0 } = options;
  return useQuery({
    queryKey: ['user-prescriptions', userId, { limit, skip }],
    enabled: userId != null && userId !== '',
    queryFn: async () => {
      const res = await getPrescriptionService().getUserPrescriptions(userId, { limit, skip });
      const data = res?.data?.data ?? res?.data ?? {};
      const items = data.prescriptions ?? data.items ?? [];
      return Array.isArray(items) ? items : [];
    },
  });
};
